"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const formik_1 = require("formik");
const yup = __importStar(require("yup"));
const react_select_1 = __importDefault(require("react-select"));
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = require("lodash");
const SpinnerOverlay_1 = __importDefault(require("../../../components/SpinnerOverlay/SpinnerOverlay"));
const InputField_1 = __importDefault(require("../../../components/InputField/InputField"));
const MessageSettings_1 = __importDefault(require("./MessageSettings"));
const contactInfo_1 = require("../../../helpers/contactInfo");
const DefaultTapLocation_1 = __importDefault(require("./DefaultTapLocation"));
const store_1 = require("../../../store/store");
const OrganizationSelector_1 = __importDefault(require("./OrganizationSelector"));
const Alert_1 = __importDefault(require("../../../components/Alert"));
const messageSettingsGroups = ['invitations', 'reminders', 'consumed', 'awards'];
const tapLocationGroups = ['tapLocation'];
const ContactInfoForm = ({ donorContactInformation, }) => {
    const queryClient = (0, react_query_1.useQueryClient)();
    const [emailOrPhoneOptionsWarning, setEmailOrPhoneOptionsWarning] = (0, react_1.useState)(undefined);
    const [{ initialValues, isLoading, errorMessage, confirmed, confirmSuccess }, setState] = (0, react_1.useState)({
        initialValues: contactInfo_1.contactFormInitialValues,
        isLoading: false,
        errorMessage: '',
        confirmed: false,
        confirmSuccess: false,
    });
    const { addressGroupHeadings, canChangeTapLocation, homeMobilePhoneIsRequired, homeEmailIsRequired, showSaveLifeAtWork, } = (0, store_1.useAppSelector)((state) => state.app.appSettings);
    const user = (0, store_1.useAppSelector)((state) => state.app.user);
    const defaultLocationId = user === null || user === void 0 ? void 0 : user.defaultLocationId;
    const organizationId = user === null || user === void 0 ? void 0 : user.organizationId;
    const createInitialValues = (0, react_1.useCallback)(() => {
        if (!donorContactInformation)
            return {};
        const iValues = { tapLocation: defaultLocationId, organizationId: organizationId };
        return donorContactInformation.reduce((total, current) => {
            // These settings go in checkboxes which require special handling
            if ([...messageSettingsGroups].includes(current.group)) {
                const existing = total[current.group];
                if (!current.value)
                    return total;
                // checkbox value needs to be unique, therefore set to the same as the key
                if (existing) {
                    existing.push(current.key);
                }
                else {
                    total[current.group] = [current.key];
                }
                return total;
            }
            return Object.assign(Object.assign({}, total), { [current.key]: `${current.value}` });
        }, iValues);
    }, [donorContactInformation, defaultLocationId, organizationId]);
    (0, react_1.useEffect)(() => {
        const values = createInitialValues();
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { initialValues: Object.assign(Object.assign({}, prevState.initialValues), values) })));
    }, [donorContactInformation, createInitialValues]);
    const validationSchema = () => {
        const baseSchema = yup
            .object()
            .shape({
            tapLocation: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable(),
            }),
            homeAddress: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.required(__.trans('user.settings-field-required')),
            }),
            homeZipCode: yup
                .number()
                .typeError(__.trans('user.settings-field-numeric'))
                .when({
                is: (exists) => !!exists,
                then: (schema) => schema.required(__.trans('user.settings-field-required')),
            }),
            homePostalAddress: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.required(__.trans('user.settings-field-required')),
            }),
            homePhone: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable().matches(/^[\d\s\-+]+$/, __.trans('user.settings-field-phone-number')),
            }),
            homeOtherPhone: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable().matches(/^[\d\s\-+]+$/, __.trans('user.settings-field-phone-number')),
            }),
            homeMobilePhone: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable().matches(/^[\d\s\-+]+$/, __.trans('user.settings-field-phone-number')),
            }),
            homeEMail: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.email(__.trans('user.settings-field-email')),
            }),
            workPlace: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable(),
            }),
            workAddress: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable(),
            }),
            workZipCode: yup
                .number()
                .typeError(__.trans('user.settings-field-numeric'))
                .when({
                is: (exists) => !!exists,
                then: (schema) => schema.required(__.trans('user.settings-field-required')),
            }),
            workPostalAddress: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable(),
            }),
            workPhone: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable().matches(/^[\d\s\-+]+$/, __.trans('user.settings-field-phone-number')),
            }),
            workEMail: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable().email(__.trans('user.settings-field-email')),
            }),
            otherAddress: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable(),
            }),
            otherZipCode: yup
                .number()
                .typeError(__.trans('user.settings-field-numeric'))
                .when({
                is: (exists) => !!exists,
                then: (schema) => schema.required(__.trans('user.settings-field-required')),
            }),
            otherPostalAddress: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable(),
            }),
            otherPhone: yup.string().when({
                is: (exists) => !!exists,
                then: (schema) => schema.nullable().matches(/^[\d\s\-+]+$/, __.trans('user.settings-field-phone-number')),
            }),
            preferredAddressType: yup.number().when({
                is: (exists) => !!exists,
                then: (schema) => schema.typeError(__.trans('user.settings-field-numeric')),
            }),
            invitations: yup.array().when({
                is: (exists) => !!exists,
                then: (schema) => schema.required(__.trans('user.contact-info-invitations-required')),
            }),
            reminders: yup.array().when({
                is: (exists) => !!exists,
                then: (schema) => schema.required(__.trans('user.contact-info-reminders-required')),
            }),
            awards: yup.array().when({
                is: (exists) => !!exists,
                then: (schema) => schema.required(__.trans('user.contact-info-award-message-required')),
            }),
        })
            .test('at-least-one-invitation-option', __.trans('user.contact-info-invitations-required'), (value) => !!(value.invitations && value.invitations.length > 0))
            .test('at-least-one-reminder-option', __.trans('user.contact-info-reminders-required'), (value) => !!(value.reminders && value.reminders.length > 0))
            .test('at-least-one-award-message-option', __.trans('user.contact-info-award-message-required'), (value) => {
            return !!(value.awards && value.awards.length > 0);
        });
        /*
         *TODO - This is a temporary solution.
         * The validation should be done by implementing DCI_ENABLED in config.php.
         * DCI_ENABLED doesn't exist as an option today.
         */
        if (homeMobilePhoneIsRequired && homeEmailIsRequired) {
            return baseSchema.shape({
                homeMobilePhone: baseSchema.fields.homeMobilePhone.when('homeEMail', {
                    is: (exists) => exists,
                    then: (schema) => schema,
                    otherwise: (schema) => schema.required(__.trans('user.settings-field-required')),
                }),
                homeEMail: baseSchema.fields.homeEMail.when('homeMobilePhone', {
                    is: (exists) => exists,
                    then: (schema) => schema,
                    otherwise: (schema) => schema.required(__.trans('user.settings-field-required')),
                }),
            }, [['homeMobilePhone', 'homeEMail']]);
        }
        if (homeEmailIsRequired) {
            return baseSchema.shape({
                homeEMail: baseSchema.fields.homeEMail.required(__.trans('user.settings-field-required')),
            });
        }
        if (homeMobilePhoneIsRequired) {
            return baseSchema.shape({
                homeMobilePhone: baseSchema.fields.homeMobilePhone.required(__.trans('user.settings-field-required')),
            });
        }
        return baseSchema;
    };
    const resolveOptions = (fieldName) => {
        switch (fieldName) {
            case 'preferredAddressType':
                return [
                    { label: __.trans('user.address-group-home'), value: '1' },
                    { label: __.trans('user.address-group-work'), value: '2' },
                    { label: __.trans('user.address-group-other'), value: '3' },
                ];
            default:
                return [];
        }
    };
    const generateFields = () => {
        const groups = _.uniq(donorContactInformation
            .filter((i) => ![...messageSettingsGroups, ...tapLocationGroups].includes(i.group))
            .map((item) => item.group));
        return groups.map((group) => ((0, jsx_runtime_1.jsxs)("div", { children: [addressGroupHeadings && ((0, jsx_runtime_1.jsx)("h5", { className: "py-1", children: (0, jsx_runtime_1.jsx)("strong", { children: __.trans(`user.address-group-${group}`) }) })), donorContactInformation
                    .filter((x) => x.group === group)
                    .map((item) => {
                    var _a;
                    if (typeof item.value === 'number' && item.type !== 'hidden') {
                        return ((0, jsx_runtime_1.jsx)(formik_1.Field, { name: item.key, children: ({ field, form }) => ((0, jsx_runtime_1.jsx)(react_select_1.default, { name: item.key, options: resolveOptions(item.key), classNamePrefix: "react-select", onChange: (selectedOption) => form.setFieldValue(field.name, selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value), value: resolveOptions(item.key).find((option) => option.value === field.value), "aria-label": item.name }, item.key)) }, item.key));
                    }
                    if (item.key.includes('homePostalAddress')) {
                        return null;
                    }
                    return ((0, jsx_runtime_1.jsx)(InputField_1.default, { name: item.key, id: item.key, type: (_a = item.type) !== null && _a !== void 0 ? _a : 'text', label: item.type === 'hidden' ? '' : item.name, disabled: item.disabled || false }, item.key));
                })] }, group)));
    };
    const buildPayload = (values) => {
        // Checkbox values need to be converted to key-value pairs with boolean value again
        // The checkbox values from the form are equal to the property name. If the property exist among the values
        // from the form, it should have the value true, otherwise false.
        const aInit = Object.values(_.pick(initialValues, messageSettingsGroups)).flat();
        const aSent = Object.values(_.pick(values, messageSettingsGroups)).flat();
        const contactInformation = _.omit(values, messageSettingsGroups);
        // Exist in initial but not in submitted values -> these should be set to false
        const msgSettingsFalse = _.difference(aInit, aSent).reduce((prev, current) => (Object.assign(Object.assign({}, prev), { [current]: false })), {});
        // Exists in both initial and submitted values -> set to true
        const msgSettingsUnchangedTrue = _.intersection(aInit, aSent).reduce((prev, current) => (Object.assign(Object.assign({}, prev), { [current]: true })), {});
        // Exist in submitted but not in initial values -> these should be set to true
        const msgSettingsTrue = _.difference(aSent, aInit).reduce((prev, current) => (Object.assign(Object.assign({}, prev), { [current]: true })), {});
        return _.merge(contactInformation, msgSettingsFalse, msgSettingsTrue, msgSettingsUnchangedTrue);
    };
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto',
        });
    };
    const handleSubmitClick = () => {
        scrollToTop();
    };
    const handleSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { confirmed: false })));
        scrollToTop();
        const payload = buildPayload(values);
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { isLoading: true })));
        const updatedState = {
            isLoading: false,
            confirmed: true,
            confirmSuccess: false,
            errorMessage: '',
        };
        const putDonorContactInfo = () => axios.put('/api/put-donor-contact-information', (0, lodash_1.omit)(payload, ['tapLocation']));
        const putDefaultLocation = () => axios.put('/api/put-default-location', { locationId: payload.tapLocation });
        axios
            .all([putDonorContactInfo(), putDefaultLocation()])
            .then(() => {
            updatedState.confirmSuccess = true;
        })
            .catch((err) => {
            updatedState.errorMessage = err.message;
            console.error('Form submission error:', err.message);
        })
            .finally(() => __awaiter(void 0, void 0, void 0, function* () {
            yield queryClient.invalidateQueries({ queryKey: ['GetDonorContactInformation'] });
            yield queryClient.invalidateQueries({ queryKey: ['get-user'] });
            setState((prevState) => (Object.assign(Object.assign({}, prevState), updatedState)));
        }));
    });
    const renderConfirmation = () => ((0, jsx_runtime_1.jsxs)(Alert_1.default, { color: confirmSuccess ? 'success' : 'danger', isOpen: confirmed, children: [__.trans(`${confirmSuccess
                ? 'user.contact-info-update-successful'
                : 'user.contact-info-update-unsuccessful'}`), errorMessage && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), errorMessage] }))] }));
    const renderEmailOrPhoneOptionsWarning = () => {
        return ((0, jsx_runtime_1.jsx)(Alert_1.default, { color: "warning", isOpen: !!emailOrPhoneOptionsWarning, children: emailOrPhoneOptionsWarning === null || emailOrPhoneOptionsWarning === void 0 ? void 0 : emailOrPhoneOptionsWarning.message }));
    };
    const tapLocationField = {
        name: 'tapLocation',
        key: 'tapLocation',
        group: 'tapLocation',
        value: defaultLocationId !== null && defaultLocationId !== void 0 ? defaultLocationId : null,
    };
    const organizationField = {
        name: 'organizationId',
        key: 'organizationId',
        group: 'organizationId',
        value: organizationId !== null && organizationId !== void 0 ? organizationId : 0,
    };
    // console.log('initialValues', initialValues)
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)(SpinnerOverlay_1.default, { visible: isLoading, children: [renderConfirmation(), renderEmailOrPhoneOptionsWarning(), (0, jsx_runtime_1.jsx)(formik_1.Formik, { enableReinitialize: true, initialValues: initialValues, validationSchema: validationSchema(), onSubmit: handleSubmit, validate: (values) => {
                        // console.log('values', values)
                        const errors = {};
                        if (values.invitations.length === 0) {
                            errors.invitations = __.trans('user.one-is-required');
                        }
                        return errors;
                    }, children: ({ values, setFieldValue }) => {
                        return ((0, jsx_runtime_1.jsxs)(formik_1.Form, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "grid-container", children: [(0, jsx_runtime_1.jsxs)("div", { className: "fields-container", children: [(0, jsx_runtime_1.jsx)("h5", { children: __.trans('user.contact-information') }), generateFields(), showSaveLifeAtWork && (0, jsx_runtime_1.jsx)(OrganizationSelector_1.default, { field: organizationField })] }), (0, jsx_runtime_1.jsxs)("div", { className: "message-settings-container", children: [(0, jsx_runtime_1.jsx)(MessageSettings_1.default, { fields: donorContactInformation.filter((i) => messageSettingsGroups.includes(i.group)), values: values, setFieldValue: setFieldValue, setWarning: setEmailOrPhoneOptionsWarning }), canChangeTapLocation && (0, jsx_runtime_1.jsx)(DefaultTapLocation_1.default, { field: tapLocationField })] })] }), (0, jsx_runtime_1.jsx)("button", { type: "submit", onClick: handleSubmitClick, className: "btn theme-button-primary my-3", children: __.trans('user.save-settings') })] }));
                    } })] }) }));
};
exports.default = ContactInfoForm;
